<div class="record">
  <div class="title">
    <b>{{gear.type}}</b>
    <span class="fa fa-fw fa-road" *ngIf="gear.KmServiceInterval>0"></span>
    <span class="fa fa-fw fa-clock-o" *ngIf="gear.MinutesServiceInterval>0"></span>
  </div>
  <div pTooltip="Edit component" tooltipPosition="left" class="fa hubtiger-edit edit font-button"
       (click)="editComponent($event)">
  </div>
  <div class="record-row">
    <div class="label">{{ 'bikeshop.modal.shared.component.manufacturer' | translate}}:</div>
    <div class="value">{{gear.manufacturer}}</div>
  </div>
  <div class="record-row">
    <div class="label">{{ 'bikeshop.modal.shared.component.description' | translate}}:</div>
    <div class="value">{{gear.note}}</div>
  </div>
  <div class="record-row">
    <div class="label">{{ 'bikeshop.modal.shared.component.last_service' | translate}}:</div>
    <div class="value">{{gear.lastService | date : countryData.AngularDateFormat }}</div>
  </div>
  <div></div>
  <div *ngIf='gear.serviceTimeframe==="km"' class="margin-top-16">
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.service_intervals' | translate}}:</div>
      <div class="value">{{gear.serviceInterval}} {{distanceMetric}}</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.next_service_in' | translate}}:</div>
      <div class="value">{{gear.kmToNextService}} {{distanceMetric}}</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.current_distance' | translate}}:</div>
      <div class="value">{{gear.totalKm}} {{distanceMetric}}</div>
    </div>
  </div>
  <div *ngIf='gear.serviceTimeframe==="hours"' class="margin-top-16">
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.service_intervals' | translate}}:</div>
      <div class="value">{{gear.serviceInterval}} Hrs</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.next_service_in' | translate}}:</div>
      <div class="value">{{gear.hoursToNextService}} Hrs</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.current_hours' | translate}}:</div>
      <div class="value">{{gear.hoursSinceLastService}} Hrs</div>
    </div>
  </div>
  <div *ngIf='gear.serviceTimeframe==="months"' class="margin-top-16">
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.service_intervals' | translate}}:</div>
      <div class="value">{{gear.serviceInterval}} mo</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.next_service_in' | translate}}:</div>
      <div class="value">{{gear.monthsToNextService}} mo</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.current_months' | translate}}:</div>
      <div class="value">{{gear.monthsSinceLastService}} mo</div>
    </div>
  </div>
  <div *ngIf='gear.serviceTimeframe!=="km" && gear.serviceTimeframe!=="hours" && gear.serviceTimeframe!=="months"' class="margin-top-16">
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.current_distance' | translate}}:</div>
      <div class="value">{{gear.totalKm}} {{distanceMetric}}</div>
    </div>
    <div class="record-row">
      <div class="label">{{ 'bikeshop.modal.shared.component.current_hours' | translate}}:</div>
      <div class="value">{{gear.totalHours}} Hrs</div>
    </div>
  </div>
  <div style="margin-top:auto;padding-top:8px;">
    <div class="record-column">
      <div class="label">{{ 'bikeshop.modal.shared.component.service_indicator' | translate}}:</div>
      <div>
          <p-progressBar [value]="100 - gear.serviceScore">
          </p-progressBar>
      </div>
    </div>
  </div>
</div>
